import React from 'react'
import {
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    Stack,
    Text,
    useStyleConfig,
    Radio,
    RadioGroup,
    Flex,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useIntl} from 'react-intl'
import {useHistory} from 'react-router-dom'
import PropTypes from 'prop-types'
import {ChevronDown} from '../../../components/icons'

const SortByAccordionItem = ({
    selectedSortingOptionLabel,
    sortUrls,
    productSearchResult,
    onSelect,
}) => {
    const {formatMessage} = useIntl()
    const history = useHistory()
    const style = useStyleConfig('SortByAccordionItem')
    const [value, setValue] = React.useState(selectedSortingOptionLabel?.label)

    const handleChange = (newValue) => {
        const selectedOption = productSearchResult?.sortingOptions.find(
            (option) => option.label === newValue,
        )
        const selectedUrl = sortUrls[productSearchResult?.sortingOptions.indexOf(selectedOption)]
        setValue(newValue)
        history.push(selectedUrl)
        onSelect()
    }
    return (
        <AccordionItem key="show-all" {...style.accordionItem}>
            <AccordionButton {...style?.button}>
                <Text {...style?.headerTextAccordion}>
                    {formatMessage(
                        {
                            id: 'sort_accordion.button.sort_by',
                            defaultMessage: 'Sort by',
                        },
                        {
                            sortOption: selectedSortingOptionLabel?.label,
                        },
                    )}
                </Text>
                <ChevronDown />
            </AccordionButton>
            <AccordionPanel {...style?.panel}>
                <RadioGroup onChange={handleChange} value={value}>
                    <Stack {...style?.stack} spacing={1}>
                        {productSearchResult?.sortingOptions?.map((option, idx) => (
                            <Flex {...style?.item} key={idx}>
                                <Text {...style?.text} padding={0}>
                                    {option.label}
                                </Text>
                                <Radio {...style?.radioDrawer} value={option.label} />
                            </Flex>
                        ))}
                    </Stack>
                </RadioGroup>
            </AccordionPanel>
        </AccordionItem>
    )
}

SortByAccordionItem.propTypes = {
    selectedSortingOptionLabel: PropTypes.shape({
        label: PropTypes.string,
    }),
    sortUrls: PropTypes.arrayOf(PropTypes.string).isRequired,
    productSearchResult: PropTypes.shape({
        sortingOptions: PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string,
            }),
        ),
    }),
    onSelect: PropTypes.func,
}

export default SortByAccordionItem
